import React from "react";
import "./styles.scss";

import Button from "../../../common/button";
import Input from "../../../common/Input";
import { isEmailAddressValid } from "../../../utils";

const ContactUsInfo = ({
  setContactData,
  contactData,
  handleUpdate,
  emailValidation,
  setEmailValidation,
}) => {
  // validation
  const handleValidateInput = () => {
    var errorHandle = false;
    if (!contactData) {
      document.getElementById("email_address")?.focus();
      setEmailValidation("Please enter the email address.");
      errorHandle = true;
    } else if (!isEmailAddressValid(contactData)) {
      document.getElementById("email_address")?.focus();
      setEmailValidation("Please enter the valid email address.");
      errorHandle = true;
    }
    if (!errorHandle) {
      handleUpdate();
    }
  };
  return (
    <div className="contactinfo-container">
      <div>
        <p>Email address</p>
        <Input
          placeholder="Enter your email address"
          className="inputfield-box"
          value={contactData}
          name="email_address"
          id="email_address"
          onChange={(event) => {
            setContactData(event.target.value);
            setEmailValidation("");
          }}
        />
        {emailValidation && (
          <p className="validation_error">{emailValidation}</p>
        )}
        <span>
          Order number and receipt will be sent to this email address.
        </span>
      </div>
      <div className="btn">
        <Button onClick={handleValidateInput}>Proceed to shipping</Button>
      </div>
    </div>
  );
};

export default ContactUsInfo;
